import { render, staticRenderFns } from "./content-recommendation.vue?vue&type=template&id=17b70c98&"
import script from "./content-recommendation.vue?vue&type=script&lang=js&"
export * from "./content-recommendation.vue?vue&type=script&lang=js&"
import style0 from "./content-recommendation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports